import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { useFormContext } from 'react-hook-form';
import dayjs from 'dayjs';
import { FormControl, FormHelperText } from '@mui/material';

type DatePickerKitProps = {
  name: string;
} & DatePickerProps<any>;

export const DatePickerKit = (props: DatePickerKitProps) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const formValue = watch(props.name);

  const onInputChange = (value: any) => {
    setValue(props.name, value.$d);
  };

  const errorMessage: any = !!errors[props.name]?.message
    ? errors[props.name]?.message
    : '';

  const isError = !!errorMessage;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl fullWidth error={isError}>
        <DatePicker
          sx={{ '.MuiInputBase-input': { padding: '8.5px 14px' } }}
          value={formValue ? dayjs(formValue) : null}
          onChange={onInputChange}
          {...props}
        />
        <FormHelperText error={isError}>{errorMessage}</FormHelperText>
      </FormControl>
    </LocalizationProvider>
  );
};
